export const viewFrameQueryKeys = {
  all: ['exams'],
  details: () => [...viewFrameQueryKeys.all, 'detail'],
  detail: (id) => [...viewFrameQueryKeys.details(), id],
  pagination: (page: number, studyUID?: string, viewName?: string) => [
    'view-frame-pagination',
    page,
    studyUID,
    viewName,
  ],
  infinite: () => [...viewFrameQueryKeys.all, 'infinite'],
  generalViewerInstances: (
    studyUID: string,
    seriesIds?: string[],
    filters?: { viewCodes?: string[]; qualityFlagCodes?: string[]; categoryGroups?: string[] }
  ) => [
    'general-viewer-instances',
    studyUID,
    ...(seriesIds && seriesIds.length > 0 && seriesIds[0] !== 'All' ? [seriesIds.slice().sort().join(',')] : []),
    ...(filters?.viewCodes?.length ? [filters.viewCodes.slice().sort().join(',')] : []),
    ...(filters?.qualityFlagCodes?.length ? [filters.qualityFlagCodes.slice().sort().join(',')] : []),
    ...(filters?.categoryGroups?.length ? [filters.categoryGroups.slice().sort().join(',')] : []),
  ],
  generalViewerInstanceFrames: (
    studyUID: string,
    sopInstanceUID: string,
    filters?: { viewCodes?: string[]; qualityFlagCodes?: string[]; categoryGroups?: string[] },
    page?: number,
    pageSize?: number
  ) => [
    'general-viewer-instance-frames',
    studyUID,
    sopInstanceUID,
    ...(filters?.viewCodes?.length ? [filters.viewCodes.slice().sort().join(',')] : []),
    ...(filters?.qualityFlagCodes?.length ? [filters.qualityFlagCodes.slice().sort().join(',')] : []),
    ...(filters?.categoryGroups?.length ? [filters.categoryGroups.slice().sort().join(',')] : []),
    ...(page != null ? [page] : []),
    ...(pageSize != null ? [pageSize] : []),
  ],
};
